"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _keyDownHandler = _interopRequireDefault(require("../../handlers/keyDownHandler"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var Button = /*#__PURE__*/function (_Component) {
  function Button(props) {
    var _this;
    _classCallCheck(this, Button);
    _this = _callSuper(this, Button, [props]);
    _this.btnRef = /*#__PURE__*/_react["default"].createRef();
    _this.state = {
      step: "initial",
      //initial, loading, done
      clicked: false,
      hideLoadingText: false
    };
    _this.handleClickEvent = _this.handleClickEvent.bind(_this);
    _this.reset = _this.reset.bind(_this);
    _this.startAnimation = _this.startAnimation.bind(_this);
    _this.stopAnimation = _this.stopAnimation.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    _this.hideLoadingText = _this.hideLoadingText.bind(_this);
    return _this;
  }
  _inherits(Button, _Component);
  return _createClass(Button, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.animated) {
        this.setState({
          hideLoadingText: this.hideLoadingText()
        });
      }
    }
  }, {
    key: "onChange",
    value: function onChange(event) {
      this.props.onChange(event);
    }
  }, {
    key: "handleClickEvent",
    value: function handleClickEvent(e) {
      var _this2 = this;
      var self = this;
      if (this.props.animateOnClick) {
        if (!self.state.clicked) {
          self.setState({
            clicked: true
          }, function () {
            self.props.onClick(e, _this2);
            self.startAnimation();
          });
        }
      } else {
        self.props.onClick(e, this);
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      this.setState({
        step: "initial",
        clicked: false
      });
    }
  }, {
    key: "hideLoadingText",
    value: function hideLoadingText() {
      var _this$btnRef;
      if (((_this$btnRef = this.btnRef) === null || _this$btnRef === void 0 || (_this$btnRef = _this$btnRef.current) === null || _this$btnRef === void 0 || (_this$btnRef = _this$btnRef.childNodes) === null || _this$btnRef === void 0 ? void 0 : _this$btnRef.length) > 3) {
        var basePxSize = window.innerWidth > 1440 ? 16 : 14;
        var spinnerPaddingAdj = {
          "big": 3 * basePxSize,
          "medium": 2 * basePxSize,
          "small": basePxSize,
          "xsmall": basePxSize
        };
        var btnLength = this.btnRef.current.offsetWidth;
        var spinnerWidth = this.btnRef.current.childNodes[4].offsetWidth + spinnerPaddingAdj[this.props.size]; // +24 is the padding of the spinner
        var loadingTextWidth = this.btnRef.current.childNodes[2].offsetWidth;
        var doneTextWidth = this.btnRef.current.childNodes[3].offsetWidth;
        var textUsed = loadingTextWidth > doneTextWidth ? loadingTextWidth : doneTextWidth;
        var sizeAdjustment = btnLength - spinnerWidth - (btnLength - textUsed) / 2;
        if (loadingTextWidth > sizeAdjustment || doneTextWidth > sizeAdjustment) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "startAnimation",
    value: function startAnimation() {
      this.setState({
        step: "loading",
        hideLoadingText: this.hideLoadingText()
      });
    }
  }, {
    key: "stopAnimation",
    value: function stopAnimation() {
      this.setState({
        step: "done"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var size = "btn-" + this.props.size;
      var shapeStyle = "btn-" + this.props.shapeStyle;
      var radius = "btn-" + this.props.radius;
      var step = "state-" + this.state.step;
      var iconPosition = "icon-" + this.props.iconPosition;
      var btnCss = (0, _classnames["default"])(radius, shapeStyle, size, this.props.colorTheme, step, iconPosition, {
        "btn-animated-loading": this.props.animated,
        "disabled": this.props.disabled,
        "fileUploaderF": this.props.type === "file",
        "noText": this.props.noText,
        "noLoadingText": this.state.hideLoadingText
      }, this.props.className);
      var spinnerClass = "spinner-" + this.state.step;
      var spinnerCss = (0, _classnames["default"])("spinner-progress", spinnerClass);
      var checkCss = (0, _classnames["default"])("checkmark", {
        "draw": this.state.step === "done"
      });
      var style = _objectSpread({}, this.props.style);
      if (this.props.animated) {
        if (this.props.type === "file") {
          return /*#__PURE__*/_react["default"].createElement("div", {
            onClick: this.handleClickEvent,
            style: style,
            className: "btn ".concat(btnCss),
            tabIndex: this.props.tabIndex,
            onKeyDown: function onKeyDown(event) {
              var key = _keyDownHandler["default"].getKeysFromEvent(event);
              if (key === _keyDownHandler["default"].keys.enter) {
                _this3.btnRef.current.click();
              }
            }
          }, /*#__PURE__*/_react["default"].createElement("input", {
            ref: this.btnRef,
            type: "file",
            onChange: this.onChange,
            accept: this.props.fileAccept
          }), /*#__PURE__*/_react["default"].createElement("span", {
            className: "hide"
          }, this.props.text), /*#__PURE__*/_react["default"].createElement("span", {
            className: "caption"
          }, this.props.text), /*#__PURE__*/_react["default"].createElement("span", {
            className: "caption loading"
          }, this.props.loadingText), /*#__PURE__*/_react["default"].createElement("span", {
            className: "caption done"
          }, this.props.doneText), /*#__PURE__*/_react["default"].createElement("div", {
            className: spinnerCss
          }, /*#__PURE__*/_react["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            xmlnsXlink: "http://www.w3.org/1999/xlink",
            version: "1.1",
            viewBox: "0 0 45 45",
            preserveAspectRatio: "none"
          }, /*#__PURE__*/_react["default"].createElement("circle", {
            className: "inner-circle",
            cx: "50%",
            cy: "50%",
            r: "21"
          }), /*#__PURE__*/_react["default"].createElement("circle", {
            className: "outer-circle",
            cx: "50%",
            cy: "50%",
            r: "21"
          })), /*#__PURE__*/_react["default"].createElement("svg", {
            className: checkCss,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 52 52"
          }, /*#__PURE__*/_react["default"].createElement("path", {
            fill: "none",
            d: "M14.1 27.2l7.1 7.2 16.7-16.8"
          }))));
        } else {
          return /*#__PURE__*/_react["default"].createElement("button", {
            ref: this.btnRef,
            formNoValidate: true,
            type: this.props.type,
            onClick: this.handleClickEvent,
            style: style,
            className: "btn ".concat(btnCss),
            tabIndex: this.props.tabIndex,
            disabled: this.props.disabled
          }, /*#__PURE__*/_react["default"].createElement("span", {
            className: "hide"
          }, this.props.text), /*#__PURE__*/_react["default"].createElement("span", {
            className: "caption"
          }, this.props.text), /*#__PURE__*/_react["default"].createElement("span", {
            className: "caption loading"
          }, this.props.loadingText), /*#__PURE__*/_react["default"].createElement("span", {
            className: "caption done"
          }, this.props.doneText), /*#__PURE__*/_react["default"].createElement("div", {
            className: spinnerCss
          }, /*#__PURE__*/_react["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            xmlnsXlink: "http://www.w3.org/1999/xlink",
            version: "1.1",
            viewBox: "0 0 45 45",
            preserveAspectRatio: "none"
          }, /*#__PURE__*/_react["default"].createElement("circle", {
            className: "inner-circle",
            cx: "50%",
            cy: "50%",
            r: "21"
          }), /*#__PURE__*/_react["default"].createElement("circle", {
            className: "outer-circle",
            cx: "50%",
            cy: "50%",
            r: "21"
          })), /*#__PURE__*/_react["default"].createElement("svg", {
            className: checkCss,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 52 52"
          }, /*#__PURE__*/_react["default"].createElement("path", {
            fill: "none",
            d: "M14.1 27.2l7.1 7.2 16.7-16.8"
          }))));
        }
      } else {
        if (this.props.type === "file") {
          return /*#__PURE__*/_react["default"].createElement("div", {
            style: style,
            className: "btn ".concat(btnCss),
            onClick: function onClick(e) {
              _this3.props.onClick(e, _this3);
            },
            tabIndex: this.props.tabIndex,
            onKeyDown: function onKeyDown(event) {
              var key = _keyDownHandler["default"].getKeysFromEvent(event);
              if (key === _keyDownHandler["default"].keys.enter) {
                _this3.btnRef.current.click();
              }
            }
          }, /*#__PURE__*/_react["default"].createElement("p", null, this.props.text), /*#__PURE__*/_react["default"].createElement("input", {
            ref: this.btnRef,
            type: "file",
            onChange: this.onChange,
            disabled: this.props.disabled
          }));
        } else {
          return /*#__PURE__*/_react["default"].createElement("button", {
            formNoValidate: true,
            type: this.props.type,
            style: style,
            className: "btn ".concat(btnCss),
            onClick: function onClick(e) {
              _this3.props.onClick(e, _this3);
            },
            tabIndex: this.props.tabIndex,
            disabled: this.props.disabled
          }, this.props.text, this.props.children);
        }
      }
    }
  }]);
}(_react.Component);
Button.propTypes = {
  radius: _propTypes["default"].oneOf(["round", "square"]),
  shapeStyle: _propTypes["default"].oneOf(["fill", "stroke"]),
  size: _propTypes["default"].oneOf(["xsmall", "small", "medium", 'big']),
  colorTheme: _propTypes["default"].oneOf(["teal", "grey", "white", 'red', "purple"]),
  text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  iconPosition: _propTypes["default"].oneOf(['right', 'left']),
  onClick: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  animated: _propTypes["default"].bool,
  animateOnClick: _propTypes["default"].bool,
  loadingText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  doneText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  type: _propTypes["default"].oneOf(["button", "submit", 'reset', "file"]),
  tabIndex: _propTypes["default"].number,
  fileAccept: _propTypes["default"].string,
  noText: _propTypes["default"].bool
};
Button.defaultProps = {
  radius: "square",
  shapeStyle: "fill",
  size: "small",
  colorTheme: "teal",
  text: null,
  disabled: false,
  iconPosition: 'left',
  onClick: function onClick() {},
  onChange: function onChange() {},
  type: "button",
  tabIndex: 1,
  fileAccept: "",
  noText: false,
  className: "",
  style: {},
  animated: false,
  animateOnClick: true,
  loadingText: "Loading ...",
  doneText: "Done"
};
var _default = exports["default"] = Button;